import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PmHeader from './components/pm/PmHeader';
import PmFooter from './components/pm/PmFooter';
import AboutUs from './pages/AboutUs';
import HomePage from './pages/HomePage';
import ContactUs from './pages/ContactUs';
import OurServices from './pages/OurServices';
import OurServicesPrices from './pages/OurServicesPrices';
import OurServicesSlug from './pages/OurServicesSlug';
// Kept for rollback: import ScheduleCall from './pages/ScheduleCall';
import ScheduleCallV2 from './pages/ScheduleCallV2';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import MyAppointments from './pages/MyAppointments';
import AppointmentDetail from './pages/AppointmentDetail';
import LoyaltyProgress from './pages/LoyaltyProgress';
import AccountSettings from './pages/AccountSettings';

import './scss/App.scss';
import ScrollToTop from './components/ScrollToTop';
import ServiceEvaluationForm from './pages/ServiceEvaluationForm';
import QuoteEvent from './pages/QuoteEventForm';
import { CartProvider } from './context/CartContext';
import CartFloatingBar from './components/CartFloatingBar';
import CourseList from './pages/CourseList';
import CourseDetail from './pages/CourseDetail';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

const OldSlugRedirect = () => {
  const { pageIdSlug } = useParams();
  return <Navigate to={`/nuestros-servicios/${pageIdSlug}/precios`} replace />;
};

const App = () => {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router>
        <AuthProvider>
          <CartProvider>
            <ScrollToTop />
            <div className="App">
              <PmHeader />
              <Routes>
                <Route path="/nosotros" element={<AboutUs />} />
                <Route path="/nuestros-servicios" element={<OurServices />} />
                <Route path="/nuestros-servicios/precios" element={<OurServicesPrices />} />
                <Route path="/nuestros-servicios/:slug/precios" element={<OurServicesSlug />} />
                {/* Redirect old URL pattern */}
                <Route path="/nuestros-servicios/precios/:pageIdSlug" element={<OldSlugRedirect />} />
                <Route path="/contactenos" element={<ContactUs />} />
                <Route path="/agendar-cita" element={<ScheduleCallV2 />} />
                <Route path="/evaluacion-para-maquillaje-semipermanente" element={<ServiceEvaluationForm />} />
                <Route path="/cotiza-tu-evento" element={<QuoteEvent />} />
                <Route path="/cursos" element={<CourseList />} />
                <Route path="/cursos/:slug" element={<CourseDetail />} />
                {/* Auth routes */}
                <Route path="/iniciar-sesion" element={<LoginPage />} />
                <Route path="/registro" element={<RegisterPage />} />
                <Route path="/recuperar-contrasena" element={<ForgotPasswordPage />} />
                <Route path="/restablecer-contrasena" element={<ResetPasswordPage />} />
                {/* Protected routes */}
                <Route path="/mis-citas" element={<ProtectedRoute><MyAppointments /></ProtectedRoute>} />
                <Route path="/mis-citas/:id" element={<ProtectedRoute><AppointmentDetail /></ProtectedRoute>} />
                <Route path="/fidelidad" element={<ProtectedRoute><LoyaltyProgress /></ProtectedRoute>} />
                <Route path="/mi-cuenta" element={<ProtectedRoute><AccountSettings /></ProtectedRoute>} />
                <Route path="/" exact element={<HomePage />} />
              </Routes>
              <PmFooter />
              <CartFloatingBar />
            </div>
          </CartProvider>
        </AuthProvider>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
